import { saveContacts } from './services'
import { contactsToEmail } from './corporate.module'

const getDefaultState = () => {
  return {
  }
}

const state = getDefaultState()

const actions = {

  async saveContactsAction ({ dispatch, commit, rootState }, contacts) {
    const userData = rootState.auth.userData
    const token = rootState.auth.token
    const payload = {
      email_body: contactsToEmail(contacts),
      from: 'intranet@trailfinders.com',
      ieBooking: userData.system === 'IE',
      inc_awards: false,
      inc_headers_footers: false,
      originator_system: 'corpCompanyProfile',
      send_to: 'corporate@trailfinders.com',
      subject: `${userData.bookno} - Contacts Change Notification for ${userData.companyname}`,
      version: '1'
    }
    dispatch('spinner/updateLoadingAction', true, { root: true })
    const res = await saveContacts(token, payload)
    if (!res) {
      dispatch('flashMessage/set', { type: 'error', message: 'Failed to submit changes.' }, { root: true })
    } else {
      dispatch('flashMessage/set', { type: 'success', message: 'Your updates have been sent. We will be in touch. Click here to go back to your itinerary.' }, { root: true })
    }
    dispatch('spinner/updateLoadingAction', false, { root: true })
  }

}

const mutations = {
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
